import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />
        <div className="cart-page__empty">
          <h2>Your cart is empty</h2>
          <p>Explore our collection of stylish clothing and accessories!</p>
          <Link to="/shop" onClick={toTop} className="cart-page__continue-btn">
            Continue shopping
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <main className="cart-main container">
        <section className="cart-items">
          <h1>Your Cart</h1>
          <div className="cart-list">
            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;
              const price = parseFloat(product.price.replace(/,/g, ""));
              return (
                <div className="cart-row" key={`${item.id}-${item.size || ""}`}>
                  <div className="cart-thumb">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="cart-info">
                    <div className="cart-title">{product.name}</div>
                    {item.size && (
                      <div className="cart-size">Size: {item.size}</div>
                    )}
                    <div className="qty-controls">
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size || "",
                            item.quantity - 1
                          )
                        }
                      >
                        -
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size || "",
                            item.quantity + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="cart-price">
                    <div
                      className="remove"
                      onClick={() => removeFromCart(item.id, item.size || "")}
                    >
                      ×
                    </div>
                    <div className="price">
                      US${(price * item.quantity).toFixed(2)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        <aside className="cart-summary">
          <div className="summary-box">
            <div className="summary-row">
              <div>Subtotal</div>
              <div className="summary-price">US${subtotal.toFixed(2)}</div>
            </div>
            <button className="checkout-btn" onClick={handleCheckout}>
              Checkout
            </button>
            <div className="summary-note">
              Taxes & shipping calculated at checkout
            </div>
          </div>
        </aside>
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
